import { createOrbTextureKey, resolveAvatarData } from "./orbAvatar";

export const ORB_RENDER_SIZE = 64;
export const ORB_Y_OFFSET = 0;
const ORB_HOVER_DISTANCE = 3;
const ORB_HOVER_SPEED = 0.004;

export const getLocalOrbAvatarConfig = (userData, fallbackTokenId = "local-player") => {
  const avatarData = resolveAvatarData(userData);
  const textureKey = createOrbTextureKey(
    userData?.orbAvatar || { tokenId: fallbackTokenId },
  );

  return {
    avatarData,
    textureKey,
  };
};

export const preloadLocalOrbAvatar = (scene, avatarData, textureKey) => {
  if (!avatarData?.usesStaticImageOverlay || !avatarData?.image || !textureKey) return;
  if (scene.textures.exists(textureKey)) return;
  scene.load.image(textureKey, avatarData.image);
};

const getOrbHoverOffset = (scene, display) => {
  if (!display) return 0;

  let hoverPhase = display.getData("hoverPhase");
  if (typeof hoverPhase !== "number") {
    hoverPhase = (((display.x || 0) * 0.013) + ((display.y || 0) * 0.017)) % (
      Math.PI * 2
    );
    display.setData("hoverPhase", hoverPhase);
  }

  const time = scene?.time?.now || 0;
  return Math.sin(time * ORB_HOVER_SPEED + hoverPhase) * ORB_HOVER_DISTANCE;
};

const syncOrbFacing = (display, { direction = null, vx = 0 } = {}) => {
  if (!display) return;
  if (direction === 270 || vx < 0) {
    display.setFlipX(true);
  } else if (direction === 90 || vx > 0) {
    display.setFlipX(false);
  }
};

export const syncOrbDisplay = (scene, display, x, y, options = {}) => {
  if (!display) return;

  const { depth } = options;
  syncOrbFacing(display, options);
  display.setPosition(x, y - ORB_Y_OFFSET + getOrbHoverOffset(scene, display));
  if (typeof depth === "number") {
    display.setDepth(depth);
  }
};

export const createLocalOrbAvatarImage = (
  scene,
  player,
  spawn,
  avatarData,
  textureKey,
  { depth = 500, size = ORB_RENDER_SIZE } = {},
) => {
  if (
    !scene ||
    !player ||
    !spawn ||
    !avatarData?.usesStaticImageOverlay ||
    !scene.textures.exists(textureKey)
  ) {
    return null;
  }

  player.setAlpha(0);
  const orbImage = scene.add
    .image(spawn.x, spawn.y - ORB_Y_OFFSET, textureKey)
    .setDisplaySize(size, size)
    .setDepth(depth);

  syncOrbDisplay(scene, orbImage, spawn.x, spawn.y, { depth });
  return orbImage;
};

export const updateLocalOrbAvatar = (
  scene,
  player,
  orbImage,
  avatarData,
  { x, y, vx = 0, direction = null, depth } = {},
) => {
  if (!player || !avatarData?.usesStaticImageOverlay) return false;

  player.anims?.stop?.();
  player.setAlpha(0);
  syncOrbDisplay(scene, orbImage, x, y, {
    vx,
    direction,
    depth,
  });
  return true;
};
